import React from 'react';
import { NavLink } from 'react-router-dom';

const navData = [
  { id: 0, path: 'transactions' },
  { id: 1, path: 'day' },
  { id: 2, path: 'monthly' },
  { id: 3, path: 'year' },
  { id: 4, path: 'compare' },
];

function Nav() {
  return (
    <nav className="mb-5">
      <ul className="flex gap-x-3">
        {navData.map(({ id, path: label }) => (
          <li key={id}>
            <NavLink
              className={({ isActive }) =>
                `h-10 px-3 inline-flex items-center text-sm capitalize transition-colors rounded-t focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-600${
                  isActive
                    ? ' font-semibold text-brand-700 shadow-[inset_0_-2px_0_rgb(var(--brand-600))]'
                    : ' font-medium text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
                }`
              }
              to={label.toLowerCase()}
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
